/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import makeRequest from 'utils/makeRequest';
import ListingWidget from 'components_v2/common/ListingWidget';
import { connect } from 'react-redux';

const TopStoriesWrapper = props => {
  const { url } = props;
  const [tpStories, setTpStories] = useState({
    data: [],
    moreText: '',
    link: '',
    name: '',
    tn: '',
    showHTML: false,
    theme: 'numbered_list',
    sectionInfo: true,
  });
  useEffect(
    () => {
      tpStories.showHTML && props.setScrollGA && props.setScrollGA();
      if (!tpStories.showHTML) {
        makeRequest
          .get(url, { isMobile: props.isMobile }, 'skipfeedengine')
          .catch(err => console.log(err))
          .then(res => {
            if (res && res.status === 200 && res.data) {
              const {
                data: { items } = {},
                more = {},
                title = {},
                tn = '',
              } = res.data;
              setTpStories({
                ...tpStories,
                data: items,
                moreText: more.text,
                link: more.link,
                name: title.text,
                tn,
                id: 'top_stories',
                showHTML: true,
              });
            }
          });
      }
    },
    [url, tpStories.showHTML],
  );

  return (
    <React.Fragment>
      {tpStories.showHTML && (
        <ListingWidget
          className=""
          item={tpStories}
          imgWidth={100}
          morlinkOpenInNewTab={
            typeof props.morlinkOpenInNewTab !== 'undefined'
              ? props.morlinkOpenInNewTab
              : ''
          }
          gaPrefix={props.gaPrefix}
          gaCategory={props.gaCategory}
          gaAction={props.gaAction}
        />
      )}
    </React.Fragment>
  );
};

TopStoriesWrapper.propTypes = {
  url: PropTypes.string.isRequired,
  morlinkOpenInNewTab: PropTypes.string,
  gaCategory: PropTypes.string,
  gaAction: PropTypes.string,
  gaPrefix: PropTypes.string,
  setScrollGA: PropTypes.func,
  isMobile: PropTypes.bool,
};

TopStoriesWrapper.defaultProps = {
  morlinkOpenInNewTab: '',
  gaCategory: '',
  gaAction: '',
  gaPrefix: '',
  setScrollGA: null,
  isMobile: false,
};
const mapStateToProps = state => ({
  isMobile: state.isMobile,
});

export default connect(mapStateToProps)(TopStoriesWrapper);
